import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_faq_view = _resolveComponent("faq-view")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createVNode(_component_faq_view, {
      "initial-faq-sections": $props.initialFaqSections,
      "submit-contact-url": $props.submitContactUrl
    }, null, 8 /* PROPS */, ["initial-faq-sections", "submit-contact-url"])
  ]))
}